module.exports = __webpack_public_path__ + "media/images/main/work3-adfa878aac12a32cc7cd7190c726ef59.jpg";